// just local place to define project-wide constants that aren't auto-exported to user project
// ==========
export { WVC_exports_final as e } from "./index.js";
export const g = window;
//# sourceMappingURL=PrivateExports.js.map